module.exports = __webpack_public_path__ + "static/media/hp3.9bf69e05.gif";